import { combineReducers } from 'redux';

const defaultVmailDetails = {};
const vmails = (state = defaultVmailDetails, action) => {
  switch (action.type) {
    case 'GET_ALL_VMAILS':
    case 'VMAILS_SUCCESS':
      return action.vmails || defaultVmailDetails;
    case 'VMAILS_ERROR':
    default:
      return state;
  }
};

export default combineReducers({
  vmails,
});
